module.exports = __webpack_public_path__ + "img/dotmod.90324823.png";